import client from '../graphQl/apollo';
import { USER_DETAIL_ACTIONS } from './index';
import {
  GET_USER_BASIC_INFO,
  CREATE_USER,
  UPDATE_USER,
} from '../graphql/queries/userViews';
import { getUsers } from './users';
import { openSnackbar } from 'Components/content/notifier';

const { SET_USER_INFO } = USER_DETAIL_ACTIONS;

export const setUserInfo = data => dispatch =>
  dispatch({
    type: SET_USER_INFO,
    payload: data,
  });

export function getUserInfo(userId) {
  return async dispatch => {
    try {
      let data = await client.query({
        query: GET_USER_BASIC_INFO,
        variables: {
          userId,
        },
      });
      dispatch(setUserInfo(data.data.customer));
    } catch (err) {
      console.log(err);
    }
  };
}

export function createUser(data) {
  return async dispatch => {
    try {
      let response = await client.mutate({
        mutation: CREATE_USER,
        variables: {
          accountId: data.accountId,
          name: data.name,
          email: data.email,
          designation: data.designation,
          access: data.access,
          isActive: data.isActive,
        },
      });
      if (response.errors) {
        openSnackbar({
          message: 'Error while adding a user',
          variant: 'error',
        });
      } else {
        openSnackbar({
          message: 'Successfully added user',
          variant: 'success',
        });
        dispatch(getUsers('', 1, []));
      }
    } catch (err) {
      console.log(err);
    }
  };
}

export function updateUser(data) {
  return async dispatch => {
    try {
      let response = await client.mutate({
        mutation: UPDATE_USER,
        variables: {
          accountId: data.accountId,
          userId: data.userId,
          name: data.name,
          designation: data.designation,
          access: data.access,
          isActive: data.isActive,
        },
      });
      if (response.errors) {
        openSnackbar({
          message: 'Error while updating a user',
          variant: 'error',
        });
      } else {
        openSnackbar({
          message: 'Successfully updated a user',
          variant: 'success',
        });
        dispatch(getUsers('', 1, []));
      }
    } catch (err) {
      console.log(err);
    }
  };
}
